import React, { useEffect } from "react";

import NavBar from "../components/common/navBar";
import Footer from "../components/common/footer";
import Logo from "../components/common/logo";
import SEOHead from "../components/common/SEOHead";
import Socials from "../components/about/socials";
import Works from "../components/homepage/works";

import INFO from "../data/user";
import SEO from "../data/seo";

import "./styles/about.css";

function createMarkup(htmlString) {
	return {__html: htmlString};
  }

const About = () => {
	useEffect(() => {
		window.scrollTo(0, 0);
	}, []);

	const currentSEO = SEO.find((item) => item.page === "about");

	return (
		<React.Fragment>
			<SEOHead
				title="About Michele Maestrale"
				description={currentSEO.description}
				keywords={currentSEO.keywords}
				path="/about"
				image="/about.jpg"
				jsonLd={[
					{
						"@context": "https://schema.org",
						"@type": "ProfilePage",
						"@id": "https://www.northwestwind.org/about#profile",
						url: "https://www.northwestwind.org/about",
						name: "About Michele Maestrale",
						description: currentSEO.description,
						mainEntity: { "@id": "https://www.northwestwind.org/#person" },
					},
				]}
			/>

			<div className="page-content">
				<NavBar active="about" />
				<div className="content-wrapper">
					<div className="about-logo-container">
						<div className="about-logo">
							<Logo width={46} />
						</div>
					</div>

					<div className="about-container">
						<div className="about-main">
							<div className="about-right-side">
								<div className="title about-title">
									{INFO.about.title}
								</div>

								<div className="about-name">
									{INFO.main.name}
								</div>

								<div className="subtitle about-subtitle"
								dangerouslySetInnerHTML={createMarkup(INFO.about.description)}>
								</div>

								<div className="about-work-section">
									<Works />
								</div>
							</div>

							<div className="about-left-side">
								<div className="about-image-container">
									<div className="about-image-wrapper">
										<img
											src="about.jpg"
											alt="about"
											className="about-image"
										/>
									</div>
								</div>

								<div className="about-socials">
									<Socials showCvDownload />
								</div>
							</div>
						</div>
						<div className="about-socials-mobile">
							<Socials showCvDownload />
						</div>
					</div>
					<div className="page-footer">
						<Footer />
					</div>
				</div>
			</div>
		</React.Fragment>
	);
};

export default About;
